import React, { useContext, useEffect, useState } from "react";
import Matrix from "../Components/Matrix";
import { MatrixComponentProps, MatrixRecievedProps } from "../MatrixTypeProps";
import { CheckResponsiveContext } from "../../../Context/CheckResponsiveContext";
import MatrixMobileView from "../Components/MatrixMobileView";

function MatrixContainer({
  surveyAnswers,
  setSurveyAnswers,
  questionId,
  isPreview,
  questionObjVariable,
  surveyAnswersInfo,
}: MatrixRecievedProps) {
  const { isMobile } = useContext(CheckResponsiveContext);

  //handle change for combi checkbox
  const handleChangeCheckbox: MatrixComponentProps["handleChangeCheckbox"] = (
    e,
    questionId,
    indexCombi
  ) => {
    let surveyAnswersCopy = structuredClone(surveyAnswers);
    if (e.target.checked) {
      surveyAnswersCopy[questionId] = surveyAnswersCopy[questionId] || {};
      surveyAnswersCopy[questionId]["val"] =
        surveyAnswersCopy[questionId]["val"] || {};
      surveyAnswersCopy[questionId]["val"][indexCombi] = {
        rowIndex: indexCombi,
      };
    } else {
      delete surveyAnswersCopy[questionId]["val"][indexCombi];
      if (
        !surveyAnswersCopy?.[questionId]?.uploads?.length &&
        !surveyAnswersCopy?.[questionId]?.comment &&
        !Object.keys(surveyAnswersCopy?.[questionId]?.val).length
      ) {
        delete surveyAnswersCopy[questionId];
      }
    }
    setSurveyAnswers(surveyAnswersCopy);
  };
  //handle chnage input
  const handleChangeTextField: MatrixComponentProps["handleChangeTextField"] = (
    event,
    questionId,
    indexCombi
  ) => {
    const { value } = event.target;
    setSurveyAnswers((draft: MatrixComponentProps["surveyAnswers"]) => {
      draft[questionId] = draft[questionId] || {};
      if (!value.trim()) {
        delete draft[questionId]["val"][indexCombi];
        if (
          !draft?.[questionId]?.comment?.length &&
          !draft?.[questionId]?.uploads?.length &&
          !Object.keys(draft?.[questionId]?.val).length
        ) {
          delete draft[questionId];
        }
      } else {
        draft[questionId]["val"] = draft[questionId]["val"] || {};
        draft[questionId]["val"][indexCombi] = value;
      }
    });
  };
  const handleChangeNumberField: MatrixComponentProps["handleChangeNumberField"] =
    (event, questionId, indexCombi) => {
      const { valueAsNumber } = event.target;
      setSurveyAnswers((draft: MatrixComponentProps["surveyAnswers"]) => {
        draft[questionId] = draft[questionId] || {};
        if (isNaN(valueAsNumber)) {
          delete draft[questionId]["val"][indexCombi];
          if (
            !draft?.[questionId]?.uploads?.length &&
            !draft?.[questionId]?.comment &&
            !Object.keys(draft[questionId]["val"]).length
          ) {
            delete draft[questionId];
          }
        } else {
          draft[questionId]["val"] = draft[questionId]["val"] || {};
          draft[questionId]["val"][indexCombi] = valueAsNumber;
        }
      });
    };
  return (
    <>
      {isMobile ? (
        <MatrixMobileView
          surveyAnswers={surveyAnswers}
          surveyAnswersInfo={surveyAnswersInfo}
          questionId={questionId}
          isPreview={isPreview}
          handleChangeCheckbox={handleChangeCheckbox}
          handleChangeTextField={handleChangeTextField}
          handleChangeNumberField={handleChangeNumberField}
        />
      ) : (
        <Matrix
          surveyAnswers={surveyAnswers}
          surveyAnswersInfo={surveyAnswersInfo}
          questionId={questionId}
          isPreview={isPreview}
          handleChangeCheckbox={handleChangeCheckbox}
          handleChangeTextField={handleChangeTextField}
          handleChangeNumberField={handleChangeNumberField}
        />
      )}
    </>
  );
}

export default MatrixContainer;
